import ResumeEntry from "./ResumeEntry";

export { ResumeEntry };



// WEBPACK FOOTER //
// ./src/components/Resume/index.js